import { fetcher } from "@/utils/fetchers/fetcher";
import { useMutation } from "@tanstack/react-query";
import { redirectToApp } from "./redirectToApp";
import { User } from "../types/User";

interface LoginProps {
  email: string;
  password: string;
  app?: string | null;
  redirectTo?: string | null;
  recaptcha?: string | null;
}

const login = async ({ email, password, app, redirectTo, recaptcha }: LoginProps) => {
  const response = await fetcher.post<User>(
    "/users/sign_in",
    {
      user: { email, password },
      app,
      ...(recaptcha && { recaptcha_token: recaptcha }),
    },
    {
      withCredentials: true,
    },
  );

  return { ...response.data, redirectTo };
};

export function useLogin() {
  return useMutation({
    mutationFn: login,
    onSuccess: ({ token, url, redirectTo }) => {
      if (!url) {
        window.location.reload();
      } else {
        const redirect = redirectTo ? url + redirectTo : url;

        redirectToApp({ token, redirect });
      }
    },
  });
}
